export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CurrentDiscussion.vue?vue&type=template&id=2b90cf14&"


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/CurrentDiscussion.vue?vue&type=template&id=2b90cf14&
// module id = 2079
// module chunks = 1